module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"EmployeeBox":{"link":"Více informací o prodejně"}},"de":{"EmployeeBox":{"link":"Mehr Informationen über den Shop"}},"sk":{"EmployeeBox":{"link":"Viac informácií o predajni"}}}')
  delete Component.options._Ctor
}
